import models from './models'

export default {
    id: null,
    code: null,
    type: null,
    security: null,
    page: null,
    sidebar: false,
    theme: models.theme(),
    template: models.template(),
    info: models.info(),
    members: [],
    member_original: null,
    panels: [],
    groups: [],
    elements: [],
    dynamic: [],
    macros: [],
    signatures: [],
    signature_pending: false,
    pdfs: [],
    created: null,
    complete: false,
    preview: false,
    download: false,
    printing: false,
    loading: false,
    request: null,
    error: null,
    queue: [],
    session: [],
    analytics: { panels: [], total: 0 },
    otp: null,
    timeout: {
        timer: null,
        ttl: 1000 * 60 * 60 * 1.5
    },
    active_groups: []
}
